module.exports = __webpack_public_path__ + "static/allplants-logo-c824cc0d1893967d011605dd66c6d556.png";